import { version } from '../../package.json';
export default version;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/version/index.js
// module id = 1811
// module chunks = 0